import { render } from "./NotificacionesCampana.vue?vue&type=template&id=6a3400b4&scoped=true"
import script from "./NotificacionesCampana.vue?vue&type=script&lang=js"
export * from "./NotificacionesCampana.vue?vue&type=script&lang=js"

import "./NotificacionesCampana.vue?vue&type=style&index=0&id=6a3400b4&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3400b4"]])

export default __exports__